export default __webpack_public_path__ + "static/media/mongodb.452bfc77.svg";